import React, { useState } from "react";
import styles from "./StaffDailyAttendanceView.module.css";
import Dropdown from "../../components/Dropdown/Dropdown";
import TabSelector from "../../components/TabSelector/TabSelector";
import SearchBar from "../../components/SearchBar/SearchBar";
import { IoCalendarOutline } from "react-icons/io5";
import { MdQrCodeScanner } from "react-icons/md";
import IconAndLabel from "../../components/IconAndLabel/IconAndLabel";
import { BiLogIn, BiLogOut } from "react-icons/bi"; // Check in/out icons
import { IoMdCloseCircleOutline } from "react-icons/io";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { WiThermometer } from "react-icons/wi";
import { IoDocumentTextOutline } from "react-icons/io5";
import { FiEdit } from "react-icons/fi";
import CalendarInput from "../../components/CalendarInput/CalendarInput";

const StaffDailyAttendanceView = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");

  const dispatch = useDispatch();

  const handleCheckIn = () => {
    dispatch(openModal("checkInStaff"));
  };
  const handleCheckOut = () => {
    dispatch(openModal("checkOutStaff"));
  };
  const handleEdit = () => {
    dispatch(openModal("editDetails"));
  };
  const handleAbsent = () => {
    dispatch(openModal("absentDetails"));
  };

  const data = [
    {
      _id: "s1",
      staffName: "John Jacob",
      room: "Room 1",
      checkIn: "10 AM  ",
      checkOut: "5:00 PM ",
      absent: "Sick Leave",
    },
    { _id: "s2", staffName: "John Jacob" },
    { _id: "s3", studentName: "John Jacob" },
    { _id: "s4", studentName: "John Jacob" },
    { _id: "s5", studentName: "John Jacob" },
  ];

  const getColumnData = (data) => {
    return data?.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),
        staffName: <LogoWithName name={item.staffName} />,
        room: item.room || "-",
        checkIn: item.checkIn ? (
          <div className={styles.inlineStatus}>
            <span className={styles.time}>{item.checkIn.split(" By ")[0]}</span>
            <div className={styles.subscriptRow}>
              <div className={styles.divider}></div>
              <WiThermometer className={styles.icon} />
              <IoDocumentTextOutline className={styles.icon} />
            </div>
          </div>
        ) : (
          "-"
        ),

        checkOut: item.checkOut ? (
          <div className={styles.inlineStatus}>
            <span className={styles.time}>{item.checkIn.split(" By ")[0]}</span>
            <div className={styles.subscriptRow}>
              <div className={styles.divider}></div>
              <WiThermometer className={styles.icon} />
              <IoDocumentTextOutline className={styles.icon} />
            </div>
          </div>
        ) : (
          "-"
        ),

        absent: item.absent ? (
          <div className={styles.inlineStatus}>
            <span className={styles.time}>{item.absent}</span>
            <div className={styles.subscriptRow}>
              <div className={styles.divider}></div>
              
              <IoDocumentTextOutline
                className={styles.icon}
                onClick={() => console.log("Absent Notes clicked")}
              />
            </div>
          </div>
        ) : (
          "-"
        ),

        action: (
          <div style={{ display: "flex", gap: "1rem" }}>
            <BiLogIn
              size={25}
              style={{ color: "green", cursor: "pointer" }} // ✅ now green
              onClick={handleCheckIn}
            />
            <BiLogOut
              size={25}
              style={{ color: "red", cursor: "pointer" }} // ✅ now red
              onClick={handleCheckOut}
            />
            <FiEdit
              size={23}
              style={{ color: "Black", cursor: "pointer" }}
              onClick={handleEdit}
            />
          </div>
        ),
      };
    });
  };
  const columnData = getColumnData(data);

  const headings = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              const allIds = data.map((item) => item._id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Staff Name", accessor: "staffName" },
    { title: "Room", accessor: "room" },
    { title: "Check in", accessor: "checkIn" },
    { title: "Check out", accessor: "checkOut" },
    { title: "Marked Absent", accessor: "absent" },
    { title: "Action", accessor: "action" },
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.resultandcount}>
        <ResultAndCount
          label="Total Staff"
          count={10}
          bgColor="rgba(from var(--Success_Color) r g b / 0.4)"
          textColor="Text_Color"
        />
        <ResultAndCount
          label="Pending"
          count={2}
          bgColor="rgba(from var(--Primary_Color) r g b / 0.35)"
          textColor="Text_Color"
        />
        <ResultAndCount
          label="Check In"
          count={1}
          bgColor="rgba(from var(--Warning_Color) r g b / 0.3)"
          textColor="Text_Color"
        />
        <ResultAndCount
          label="Check Out"
          count={5}
          bgColor="rgba(from var(--Error_Color) r g b / 0.4)"
          textColor="Text_Color"
        />

        <ResultAndCount
          label="Absent"
          count={3}
          bgColor="rgba(from var(--Warning_Color) r g b / 0.4)"
          textColor="Text_Color"
        />
      </div>
      <div className={styles.totaltable}>
        <div className={styles.controlsBar}>
          <div className={styles.search}>
            <SearchBar
              placeholder="Search Program"
              onChange={(e) => console.log(e.target.value)}
            />
          </div>
          <div className={styles.rightrow}>
            <div className={styles.dateWrapper}>
              <CalendarInput
                label="Select Date"
                required
                value={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                background="var(--Utility_Color1)"
                placeholderColor="var(--Info_Color)"
                iconColor="var(--Grey_Color)"
                borderRadius="12px"
              />
            </div>

            <div
              className={styles.qrIcon}
              onClick={() => console.log("Open QR popup")}
            >
              <MdQrCodeScanner size={25} />
            </div>

            <IconAndLabel
              icon={<BiLogIn size={25} />}
              label="Check in"
              onClick={handleCheckIn}
            />
            <IconAndLabel
              icon={<BiLogOut size={25} />}
              label="Check out"
              onClick={handleCheckOut}
            />
            <IconAndLabel
              icon={<IoMdCloseCircleOutline size={25} />}
              label="Absent"
              onClick={handleAbsent}
            />
          </div>
        </div>

        <div className={styles.tableBox}>
          <Dynamic
            headings={headings}
            columnData={columnData.slice(
              (currentPage - 1) * itemsPerPage,
              currentPage * itemsPerPage
            )}
          />
          <PaginationTable
            data={columnData}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            setCurrentPage={setCurrentPage}
            setItemsPerPage={setItemsPerPage}
          />
        </div>
      </div>
    </div>
  );
};

export default StaffDailyAttendanceView;
